<template>
	<div v-if="isReadyForShow" class="flex justify-between text-left md:py-1 lg:py-0 text-sm">
		<div class="justify-between flex-grow w-full">
			<div class="flex w-full space-x-4">
				<div class="flex space-x-2 items-center">
					<DocumentFileUploader
						v-if="checkUploadPermission()"
						ref="upload"
						:allow-upload-in-app-container="false"
						:damage-case-id="this.$route.params.processId"
						:document="document"
						:handle-on-click="false"
						:instant-upload="!isMisc"
						:overwrite-uuid="document.uuid"
						:allow-multiple-photos="true"
						@input="checkMisc($event)"
					>
						<div class="bg-connectProBlue text-white px-1 text-xs h-5 flex items-center">
							<font-awesome-icon :icon="['fas', 'upload']" @click="openUpload" />
						</div>
					</DocumentFileUploader>

					<div
						:class="checkAllowUpload() ? 'bg-gray-400' : 'bg-connectProBlue'"
						class="text-white px-1 text-xs h-5 flex items-center border-b-2"
						v-else
					>
						<font-awesome-icon :icon="['fas', 'upload']" class="flex" :class="checkAllowUpload() ? '' : 'cursor-pointer'" />
					</div>
				</div>
				<div class="font-bold" :class="{ 'text-gray-500': !document.uuid && (!isMisc || document.type === 'damageassessor_documents') }">
					<label
						class="flex-shrink-0 break-words leading-none cursor-pointer"
						style="max-lines: 2; overflow-wrap: anywhere"
						v-if="isNameClickeable"
						@click="clickName"
						>{{ getDocumentName(document) }}</label
					>
					<label class="flex-shrink-0 break-words leading-none" v-else>{{ getDocumentName(document) }}</label>
					<label
						v-if="document.created_at"
						:title="getStringFromDate(document.created_at) + ' - ' + getTimeFromDate(document.created_at)"
						class="text-gray-500 flex-shrink-0 break-words leading-none text-sm"
					>
						({{ getStringFromDate(document.created_at) }})
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/mixins/LoadingSpinner';
import { DamagecasesApiFactory, PdfApiFactory } from '@/api/generated';
import Authentication from '@/mixins/Authentication';
import apiDefaults from '@/api/defaultConfiguration';
import DocumentFileUploader from '@/components/forms/inputs/DocumentFileUploader';
import { getStringFromDate, getTimeFromDate } from '@/plugins/Utils';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import PDFDamagecasesRepository from '@/api/repositories/PDFDamagecasesRepository';
import { isDunningDocument } from '@/helpers/Utils';

export default {
	name: 'ProcessDocumentCardTabRow',
	components: { DocumentFileUploader },
	mixins: [LoadingSpinner, Authentication, AppContainerMixin],
	props: {
		dunningStatus: {},
		document: { uuid: '', required: true },
		label: {},
		isEditAllowed: {},
		isMisc: { default: false },
	},
	data() {
		return {
			miscOverwrite: false,
			documentData: {
				uuid: '',
				url: '',
			},
			// uuid: '',
			isDownload: false,
			tempDocument: null,
			documentsArray: [],
		};
	},
	methods: {
		getDocumentName(document) {
			if (document.type === 'payment_reminder_customer_without_lawyer' || document.type === 'payment_reminder_customer_with_lawyer') {
				return this.$t('payment_reminder_first');
			} else if (
				document.type === 'second_payment_reminder_customer_without_lawyer' ||
				document.type === 'second_payment_reminder_customer_with_lawyer'
			) {
				return this.$t('payment_reminder_second');
			} else if (document.type === 'last_dunning_notice') {
				return this.$t('dunning_notice_last');
			} else if (document.type === 'first_dunning_notice') {
				return this.$t('dunning_notice');
			} else {
				return document.label;
			}
		},
		checkUploadPermission() {
			let status = false;
			if (
				(this.document.type === 'payment_order_assignment' ||
					this.document.type === 'nebenleistungen' ||
					this.document.type === 'reparatur-auftrag' ||
					this.document.type === 'vollmacht-anwalt' ||
					this.document.type === 'lawyer_payment_order' ||
					this.document.type === 'damageassessor') &&
				this.isUserAllowedInLevel5or6
			) {
				status = this.document.uuid !== null;
			} else {
				status = !this.document.upload_route && this.isUploadAllowed && this.hideIconForLawyer;
			}

			if (
				this.document.type === 'damageassessor_documents' &&
				!this.$store.getters.getDamageCase.damageAssessor?.system_assessor &&
				this.$store.getters.isProcessLiability
			) {
				return true;
			}

			return status;
		},
		checkAllowUpload() {
			if (
				(this.document.type === 'payment_order_assignment' ||
					this.document.type === 'nebenleistungen' ||
					this.document.type === 'reparatur-auftrag' ||
					this.document.type === 'vollmacht-anwalt' ||
					this.document.type === 'lawyer_payment_order' ||
					this.document.type === 'damageassessor') &&
				this.isUserAllowedInLevel5or6
			) {
				return this.document.uuid === null;
			} else {
				return !this.isUploadAllowed || (this.document.upload_route && this.isUploadAllowed);
			}
		},
		checkMisc($event) {
			if (this.isMisc) {
				this.$swal({
					title: this.$t('file_name').toString(),
					text: this.$t('enter_file_name').toString(),
					icon: 'question',
					cancelButtonText: this.$t('general.cancel').toString(),
					showCancelButton: true,
					confirmButtonText: this.$t('upload').toString(),
					input: 'text',
					inputValue: this.$refs['upload'].uploadFileName
						.split('.')
						.slice(0, -1)
						.join('.'),
				}).then(result => {
					if (result.value) {
						if (this.isAppContainer) {
							this.$store.commit('setRawPictures', {
								pictures: $event,
								type: this.document.type,
								label: result.value,
								miscOverwriteUuid: this.document.uuid,
							});
							this.$router.push({ name: 'damagecases.rotatepictures' });
						} else {
							this.$refs['upload'].triggerFileUpload(result.value, this.miscOverwrite);
						}
					}
				});
			} else {
				if (this.isAppContainer) {
					this.$store.commit('setRawPictures', { pictures: $event, type: this.document.type });
					this.$router.push({ name: 'damagecases.rotatepictures' });
				}
			}
		},
		openUpload() {
			if (!this.$store.getters.getDamageCase.repairShopReferenceNumber && this.document.type === 'reparatur-rechnung') {
				this.$swal({
					title: this.$t('process_number').toString(),
					text: this.$t('no_reference_number_saved').toString(),
					icon: 'question',
					input: 'text',
					inputValue: this.vehicleKilometrage,
					confirmButtonText: this.$t('update').toString(),
					cancelButtonText: this.$t('general.no').toString(),
					validationMessage: this.$t('enter_valid_number').toString(),
					inputValidator: inputValue => {
						if (!inputValue) {
							return this.$t('please_check_input');
						}
					},
					showCancelButton: true,
				}).then(result => {
					if (result.isConfirmed) {
						if (result.value) {
							const process = this.$store.getters.getDamageCase;
							process.repairShopReferenceNumber = result.value;
							DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
								.damagecasesIdPut(process.id, process)
								.then(response => {
									this.$store.dispatch('forceUpdateDamageCase');
									this.$swal({
										title: this.$t('general.success').toString(),
										text: this.$t('process_number_saved_upload_bill').toString(),
										icon: 'success',
									}).then(() => {
										this.checkDocumentOverwrite();
									});
								})
								.catch(e => {
									this.$swal(this.$t('general.error').toString(), this.$t('error_saving').toString(), 'error');
								});
						}
					} else {
						this.checkDocumentOverwrite();
					}
				});
			} else {
				this.checkDocumentOverwrite();
			}
		},
		checkDocumentOverwrite() {
			if (this.document.uuid) {
				this.$swal({
					title: this.$t('sure').toString(),
					text: this.$t('overwrite_file').toString(),
					icon: 'warning',
					cancelButtonText: this.$t('general.cancel').toString(),
					showCancelButton: true,
					confirmButtonText: this.$t('overwrite').toString(),
				}).then(result => {
					if (result.value) {
						this.miscOverwrite = true;
						if (this.isAppContainer) {
							this.$refs.upload?.openCamera();
						} else {
							this.$refs.upload?.openUpload();
						}
					}
				});
			} else {
				if (this.isAppContainer) {
					this.$refs.upload?.openCamera();
				} else {
					this.$refs.upload?.openUpload();
				}
			}
		},
		getStringFromDate(unixtimestamp) {
			return getStringFromDate(new Date(unixtimestamp * 1000));
		},
		getTimeFromDate(unixtimestamp) {
			return getTimeFromDate(new Date(unixtimestamp * 1000));
		},
		getMimeTypeFromArrayBuffer(arrayBuffer) {
			const uint8arr = new Uint8Array(arrayBuffer);
			const len = 4;
			if (uint8arr.length >= len) {
				const signatureArr = new Array(len);
				for (let i = 0; i < len; i++) signatureArr[i] = new Uint8Array(arrayBuffer)[i].toString(16);
				const signature = signatureArr.join('').toUpperCase();

				switch (signature) {
					case '89504E47':
						return 'image/png';
					case '47494638':
						return 'image/gif';
					case '25504446':
						return 'application/pdf';
					case 'FFD8FFDB':
					case 'FFD8FFE0':
						return 'image/jpeg';
					case '504B0304':
					case '504B34':
						return 'application/zip';
					default:
						return null;
				}
			}
			return null;
		},
		clickName() {
			this.documentData.uuid = this.document.uuid;
			new PDFDamagecasesRepository().getSavedDocument(this.document.uuid).then(response => {
				const label = response.headers['content-disposition'].split('filename=')[1];
				const documentType = this.getMimeTypeFromArrayBuffer(response.data);
				if (documentType === 'application/zip') {
					if (this.isAppContainer) {
						this.$swal(this.$t('general.attention').toString(), this.$t('tablet_no_zip_files').toString(), 'warning');
					} else {
						this.isDownload = true;
						const blob = new Blob([response.data]);
						const resolvingUrl = URL.createObjectURL(blob);
						setTimeout(function() {
							const a = document.createElement('a');
							a.style.display = 'none';
							a.href = resolvingUrl;
							a.download = label;
							document.body.appendChild(a);
							a.click();
							window.URL.revokeObjectURL(this.url);
						}, 200);
					}
				} else {
					const blob = new Blob([response.data], { type: 'application/pdf' });
					const name = response.headers['content-disposition'].split('filename=')[1];
					if (this.isAppContainer) {
						const reader = new FileReader();
						reader.onload = function() {
							const arrayBuffer = this.result;
							// convert the ArrayBuffer to a comma-separated string
							const dataString = new Uint8Array(arrayBuffer).join(',');
							const messageData = {
								fileName: name,
								data: dataString,
							};
							// send the data to Swift
							window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
						};
						reader.readAsArrayBuffer(blob);
					} else {
						const resolvingUrl = URL.createObjectURL(blob);
						const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;
						setTimeout(function() {
							window.open(viewerUrl, '_blank');
							window.URL.revokeObjectURL(viewerUrl);
						}, 200);
					}
				}
			});
		},
	},
	computed: {
		hideIconForLawyer() {
			return !(this.document.type === 'damageassessor' && this.isUserAllowedInLevel3);
		},
		isNameClickeable() {
			//return (this.document.uuid || this.document.upload_route) && (this.document.uuid || this.isUploadAllowed);
			return this.document.uuid;
		},
		isReadyForShow() {
			const isReparaturErweiterung = this.document.type === 'reparaturerweiterung_pdf' || this.document.type === 'reparaturerweiterung_zip';
			const isDocumentSet = this.document.uuid;
			const isL2AndNotDoc = this.isUserAllowedInLevel2 && !isDocumentSet;
			const isL2NotDocAndFuehrerschein = isL2AndNotDoc && this.document.type === 'führerschein';
			const dunningAndMahn = this.dunningStatus === '-' && isDunningDocument(this.document.type);
			const minL4AndZahlungsanweisung =
				!this.isUserAllowedInLevel1 && !this.isUserAllowedInLevel2 && !this.isUserAllowedInLevel3 && this.document.type === 'zahlungsanweisung';
			const isReparaturErweiterungen = this.$store.getters.getRepairExtension?.length;
			const isL2AndNoRepairShop =
				this.isUserAllowedInLevel2 && isReparaturErweiterung && (!this.$store.getters.getDamageCase.repairShop?.id || !isReparaturErweiterungen);
			const isZahlungsAnweisungAllgemein = this.document.type === 'lawyer_payment_order' && !isDocumentSet;

			if (isDunningDocument(this.document?.type)) return this.pdfURL;

			return !(isZahlungsAnweisungAllgemein || isL2AndNoRepairShop || isL2NotDocAndFuehrerschein || dunningAndMahn || minL4AndZahlungsanweisung);
		},
		isUploadAllowed() {
			const isVollmachtAnwalt = this.document.type === 'vollmacht-anwalt';
			const isZahlungsAnweisungAllgemein = this.document.type === 'lawyer_payment_order';
			const isFuehrerschein = this.document.type === 'führerschein';
			const isZahlungsanweisung = this.document.type === 'zahlungsanweisung';
			const isMiscType = this.document.type === 'misc';

			const isDamageAssessor = this.document.set === 'AppDamageAssessor';
			const isLawyer = this.document.set === 'AppLawyersOffice';
			const isCustomer = this.document.set === 'AppCustomer';
			const isMisc = this.document.set === 'misc';
			const isRepairShop = this.document.set === 'AppRepairShop';

			if (
				this.isUserAllowedInLevel5or6 &&
				this.$store.getters.isProcessComprehensive &&
				isDamageAssessor &&
				(this.$store.getters.getDamageCase.damageAssessor == null || this.$store.getters.getDamageCase.damageAssessor.system_assessor)
			) {
				return false;
			}

			const isZahlungsanweisungAndLevel2 = isZahlungsanweisung && this.isUserAllowedInLevel2;
			const permissionLevel2 = isDamageAssessor && (this.isUserAllowedInLevel2 || this.$store.getters.isProcessComprehensive);
			const permissionLevel5or6 = isRepairShop && this.isUserAllowedInLevel5or6;
			const isPermissionGranted = permissionLevel2 || permissionLevel5or6 || isLawyer || isCustomer || isMisc || isMiscType;

			if (isFuehrerschein && !this.isAppContainer) {
				return false;
			}

			if (isMisc && isMiscType && this.isUserAllowedInLevel3) {
				return true;
			}

			if ((isZahlungsanweisung || isZahlungsAnweisungAllgemein || !isLawyer) && this.isUserAllowedInLevel3) {
				return false;
			}

			if (
				(isZahlungsanweisung || isZahlungsAnweisungAllgemein || isVollmachtAnwalt) &&
				(this.$store.getters.getDamageCase.signLocation === this.$store.getters.getDamageCase.repairShop?.city.name || this.isAppContainer)
			) {
				return false;
			}

			return (isPermissionGranted && !isZahlungsanweisung) || isZahlungsanweisungAndLevel2;
		},
		isLawyerMailAllowed() {
			return !(this.getAuthenticatedUserGroupLevel !== '3' && !this.damageCase?.lawyerOffice?.isEditable);
		},
		pdfURL() {
			return this.document?.uuid ? apiDefaults.axios.defaults.baseURL + 'api/pdf/damagecases/' + this.document.uuid + '/file' : null;
		},
		damageCase() {
			return this.$store.getters.getDamageCase;
		},
		customerEmailSet() {
			return this.damageCase?.customer?.email;
		},
		customerId() {
			return this.damageCase?.customer?.id;
		},
		inuranceEmailSet() {
			return this.damageCase?.oppositeInsurance?.email;
		},
		repairShopEmailSet() {
			return this.damageCase?.customerConsultant?.email || this.damageCase?.repairShop?.email;
		},
		lawyerEmail() {
			return this.damageCase?.lawyerOffice?.email;
		},
		isLawyerDisabled() {
			return !this.lawyerEmail || this.getAuthenticatedUserGroupLevel === '3' || !this.document.allow_AppLawyersOffice;
		},
		isRepairShopDisabled() {
			return (
				!this.repairShopEmailSet ||
				this.getAuthenticatedUserGroupLevel === '5' ||
				this.getAuthenticatedUserGroupLevel === '6' ||
				!this.document.allow_AppRepairShop ||
				this.document.set === 'AppRepairShop'
			);
		},
		uuid() {
			return this.document.uuid;
		},
	},
	watch: {
		uuid: function(oldValue, newValue) {
			if (oldValue !== this.documentData.uuid) {
				this.documentData.url = '';
				this.isDownload = false;
			}
		},
	},
};
</script>
